import React, { PropTypes } from 'react';
import classNames from 'classnames';
import './CarrotSlice.less';

const CarrotSlice = (props) => {
  const {scale, rotate, type} = props;
  const className = classNames('carrot-slice', `carrot-slice-${type}`);

  return (
    <figure className={className} style={{transform: `scale(${scale}) rotate(${rotate})`}} />
  );
};

CarrotSlice.defaultProps = {
  rotate: '0deg',
  scale: 1,
  type: 1
};

CarrotSlice.propTypes = {
  rotate: PropTypes.string,
  scale: PropTypes.number,
  type: PropTypes.number
};

export default CarrotSlice;



// WEBPACK FOOTER //
// ./src/components/LegalInfo/CarrotSlice.js